import { getCookie } from '@patrianna/shared-utils'

import type { TypedThunk } from 'store/types'

import { actions } from './slice'

export const initCookieConsent = (): TypedThunk => (dispatch) => {
  if (typeof window !== 'undefined') {
    const cookie = getCookie('scd_value', document.cookie)
    if (cookie) {
      dispatch(actions.setScdValue(cookie))
    }
  }
}
